import React from 'react'
import util from '../../../util/tools'
import './style.css'

class Activity extends React.Component {
    state = {
        visible: false,
        result: null,
        position: null
    }
    componentDidMount () {
        util.ajax({
            url: "/zh/active/activeConf",
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    const { active_status, ...result } = res.result.data
                    const visible = Number(active_status) === 1
                    this.setState({
                        result,
                        visible
                    })
                }
            }
        });
    }
    // 上报
    handleSavePush(position_id) {
        util.ajax({
            url: "/zh/positioncount/push",
            data: {
                position_id
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    // console.log(res.result)
                }
            }
        });
    }
    handleActivityPush = () => {
        const { location } = this.props
        const { result: { position_id: { index, recentlyread, recharge } } } = this.state
        const objs = {
            index,
            recentlyread,
            recharge
        }
        this.handleSavePush(objs[location])
        window.location.href = `${this.state.result.jump_url}?source=${window.location.hostname}`
    }
    render() {
        if (!this.state.visible) {
            return null
        }
        return (
            <div className={this.props.notStyle ? 'activity-box' : 'activity-box-other'} onClick={() => this.handleActivityPush()}>
                <img src={this.state.result.active_small_banner} className="activity-thumb"/>
            </div>
        )
    }
}

Activity.defaultProps = {
    notStyle: true
}

export default Activity
